module.exports = __webpack_public_path__ + "img/logo-knowage8.d6d8b33d.svg";